export default {
	pageSize: 100,

	apiRoot: '//nidhoggur.rhi.hi.is/ritaskra'
	//apiRoot: 'http://130.208.178.119:8800'
}